export default "__VITE_ASSET__38832216__"